<template>
  <div>
    <div v-if="this.getGroupedBarChartData && this.getGroupedBarChartData.datasets && this.getGroupedBarChartData.datasets.length > 0">
      <horizontal-grouped-bar-chart style="position: relative; height:210px" :data="this.getGroupedBarChartData"
                         :options="this.groupedBarChartOptions"
                         ></horizontal-grouped-bar-chart>
      <v-row no-gutters>
        <v-col>
          <v-btn color="success text--darken-2 d-inline-block" right dark x-small @click="showFullListClick" :disabled="btnDisabled">
            Show full list
          </v-btn>
        </v-col>
<!--        <v-col class="text-right">-->
<!--          <v-switch class="mt-0 d-inline-block" hide-details dense v-model="filteredJobOffers"></v-switch>-->
<!--        </v-col>-->
      </v-row>
      <show-list ref="jobOffersPerPortalBarsList" :title="'job offers per company'" :list="fullList" :headers="['source', '#job offers']"></show-list>
    </div>
    <v-sheet height="200px" class="text-center d-flex align-center justify-center" v-else>
      <slot>No data to display</slot>
    </v-sheet>
  </div>
</template>

<script>
  import ShowList from "../../Dialogs/Profiles/showList";
  import HorizontalGroupedBarChart from "../Wrappers/horizontalGroupedBarChart";
  import {jobOffersColors} from "../../../constants/constants";

  export default {
    name: "jobOffersPerCompanyBars",
    components: {HorizontalGroupedBarChart, ShowList},
    props: ['jobOffers'],
    data(){
      return {
        groupedBarChartData: {},
        fullList: [],
        filteredJobOffers: true,
        groupedBarChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top"
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true,
                color: '#eee'
              },
              ticks: {
                beginAtZero: true
              }
            }],
            yAxes: [{
              gridLines: {
                display: false
              },
            }]
          },
        },
      }
    },
    methods: {
      showFullListClick() {
        this.$refs.jobOffersPerPortalBarsList.openModal();
      },
    },
    computed: {
      btnDisabled(){
        return this.groupedBarChartData.datasets ? this.groupedBarChartData.datasets.length === 0 : true;
      },
      getFilteredJobOffers() {
        return this.filteredJobOffers ? this.jobOffers.filter(e => e.company.paramsForUrl.fcv !== null) : this.jobOffers;
      },
      getGroupedBarChartData() {
        const jobOffers = this.getFilteredJobOffers;
        const allLabels = jobOffers.map(e => {
          return e.company && e.company.paramsForUrl ? e.company.name : 'Unspecified'
        }).filter((value, index, self) => self.indexOf(value) === index);

        let datasets = [];
        allLabels.forEach(label => {

          let l = jobOffers.filter(e => {
            let companyName = e.company && e.company.paramsForUrl ? e.company.name : 'Unspecified' ;
            return companyName === label
          });

          if (label !== undefined){
            let data = l.length;
            datasets.push({label, data: [data]});
          }
        });

        this.fullList = datasets.sort((a,b) => b.data[0] >= a.data[0] ? 1 : ((a.data[0] >= b.data[0]) ? -1 : 0));
        datasets = this.fullList.filter(e => e.label !== 'Unspecified').slice(0, 10);

        datasets.forEach((d,i) => d.backgroundColor = jobOffersColors[i]);

        this.groupedBarChartData = {labels: ['companies'], datasets};
        return this.groupedBarChartData;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/jobOffersPerCompanyBars.vue